import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const isFormValid = (state: BP42InitialState): boolean => state.formData.name.isValid && state.formData.phone.isValid;

export default isFormValid;
